(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const routes = window.vyomiRoutes;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat('en-AE', { style:'currency', currency:routes.currency || 'AED' }).format(cents / 100);
  const drawer = $('#cart-drawer');
  let cart = { items:[], item_count:0, total_price:0 }, pending = 0, queue = Promise.resolve(), generation = 0, toastTimer, lastFocus;
  let saved, savedOnly = false;
  try { saved = JSON.parse(localStorage.getItem('vyomi-favourites-v1') || '[]'); } catch { saved = []; }
  if (!Array.isArray(saved)) saved = [];
  async function request(path, body) {
    let response, data;
    try {
      response = await fetch(routes.root + path, { method:body ? 'POST':'GET', credentials:'same-origin', cache:'no-store',
        headers:body ? { 'Content-Type':'application/json' } : {}, body:body ? JSON.stringify(body) : undefined, signal:AbortSignal.timeout(20000) });
      data = await response.json();
    } catch { throw new Error('The shop is taking a little longer. Please try again.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Please check availability and try again.');
    return data;
  }
  function toast(message) {
    const node = $('#toast'); if (!node) return;
    node.textContent = message; node.classList.add('visible'); clearTimeout(toastTimer);
    toastTimer = setTimeout(() => node.classList.remove('visible'), 3200);
  }
  function close() {
    if (drawer) drawer.hidden = true;
    if ($('#overlay')) $('#overlay').hidden = true;
    document.body.classList.remove('locked');
    if (lastFocus?.isConnected) lastFocus.focus();
  }
  function openBag() {
    if (!drawer) { location.assign(routes.cart); return; }
    lastFocus = document.activeElement; drawer.hidden = false; $('#overlay').hidden = false;
    document.body.classList.add('locked'); $('.close-button', drawer)?.focus();
  }
  function renderCart() {
    if ($('#bag-count')) $('#bag-count').textContent = cart.item_count;
    $('.bag-button')?.setAttribute('aria-label', `Open shopping bag, ${cart.item_count} items`);
    if (!$('#cart-items')) return;
    $('#cart-items').innerHTML = cart.items.length ? cart.items.map(item => {
      const gift = item.properties?.['Gift note'] || '';
      const image = typeof item.image === 'string' && /^(?:https:)?\/\//.test(item.image) ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}">` : '';
      return `<div class="cart-item">${image}<div class="cart-item-copy"><h3><a href="${esc(item.url)}">${esc(item.product_title)}</a></h3>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${esc(item.variant_title)}</p>` : ''}${gift ? `<p>${esc(gift)}</p>` : ''}<div class="cart-item-controls"><div class="quantity" aria-label="Quantity of ${esc(item.product_title)}"><button data-cart-key="${esc(item.key)}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button data-cart-key="${esc(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity" ${item.quantity >= 20 ? 'disabled':''}>+</button></div><button class="remove-item" data-cart-key="${esc(item.key)}" data-quantity="0">Remove</button></div></div><span class="cart-item-price">${money(item.final_line_price)}</span></div>`;
    }).join('') : `<div class="cart-empty"><span>✳</span><h3>A little room for love.</h3><p>Your forever flowers are waiting to be picked.</p><a class="button button-primary" href="${esc(routes.collection)}">Explore the blooms ↗</a></div>`;
    $('#cart-footer').innerHTML = cart.items.length ? `<div class="cart-total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div><p>Shipping is free for orders more than 300AED within UAE</p><a class="button button-primary" data-checkout href="${esc(routes.checkout)}">Continue to secure checkout ↗</a><p class="checkout-note">Your final total is confirmed before payment.</p>` : '';
    $$('[data-cart-key]', drawer).forEach(button => { button.disabled = pending > 0 || Number(button.dataset.quantity) > 20; });
    $$('[data-checkout]').forEach(link => { link.setAttribute('aria-disabled', pending > 0 ? 'true':'false'); });
  }
  async function refreshCart() {
    const current = ++generation, result = await request('cart.js');
    if (current !== generation) return;
    cart = result; renderCart();
  }
  function mutate(operation) {
    pending++; renderCart();
    const task = queue.catch(() => {}).then(operation).then(refreshCart);
    queue = task;
    return task.finally(() => { pending--; renderCart(); });
  }
  function savedButtons() {
    $$('[data-save]').forEach(button => {
      const active = saved.includes(button.dataset.save);
      button.classList.toggle('is-saved', active); button.setAttribute('aria-pressed', String(active));
    });
    const cards = $$('[data-product-card]');
    cards.forEach(card => { card.hidden = savedOnly && !saved.includes(card.dataset.productCard); });
    if ($('#saved-empty')) $('#saved-empty').hidden = !savedOnly || cards.some(card => !card.hidden);
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a,[data-action]'); if (!target) return;
    if (target.matches('[data-checkout]') && pending) { event.preventDefault(); toast('Your bag is updating. Please try checkout in a moment.'); return; }
    if (target.matches('[data-save]')) {
      const id = target.dataset.save; saved = saved.includes(id) ? saved.filter(s => s !== id) : [...saved, id];
      try { localStorage.setItem('vyomi-favourites-v1', JSON.stringify(saved)); } catch { /* Browsing still works without storage. */ }
      savedButtons(); toast(saved.includes(id) ? 'A flower crush, saved. ♡' : 'Removed from your favourites.'); return;
    }
    if (target.matches('[data-add-variant]')) {
      target.disabled = true;
      try { await mutate(() => request('cart/add.js', { items:[{ id:target.dataset.addVariant, quantity:1 }] })); toast('A lovely choice. It’s in your bag. ♡'); }
      catch (error) { toast(error.message); } finally { target.disabled = false; }
      return;
    }
    if (target.matches('[data-cart-key]')) {
      const quantity = Number(target.dataset.quantity);
      if (!Number.isInteger(quantity) || quantity < 0 || quantity > 20 || pending) return;
      try { await mutate(() => request('cart/change.js', { id:target.dataset.cartKey, quantity })); } catch (error) { toast(error.message); }
      return;
    }
    switch (target.dataset.action) {
      case 'saved-filter': savedOnly = !savedOnly; target.setAttribute('aria-pressed', String(savedOnly)); savedButtons(); break;
      case 'bag': event.preventDefault(); openBag(); refreshCart().catch(error => toast(error.message)); break;
      case 'close': close(); break;
      case 'menu': {
        const nav = $('.nav-links'), expanded = nav?.classList.toggle('open');
        $('.mobile-menu')?.setAttribute('aria-expanded', String(!!expanded)); break;
      }
      case 'search': {
        const search = $('#site-search'); if (search) { search.hidden = !search.hidden; if (!search.hidden) $('input', search)?.focus(); } break;
      }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.vyomi-product-form')) return;
    event.preventDefault(); const button = $('button[type=submit]', form), errorNode = $('[data-product-error]', form);
    if (button.disabled) return;
    button.disabled = true; errorNode.textContent = '';
    const fields = new FormData(form), id = String(fields.get('id') || '');
    try {
      if (!/^\d+$/.test(id)) throw new Error('Please choose an available flower.');
      const note = String(fields.get('properties[Gift note]') || '').trim().slice(0, 180);
      await mutate(() => request('cart/add.js', { items:[{ id, quantity:1, properties:note ? { 'Gift note':note } : {} }] }));
      openBag();
    } catch (error) { errorNode.textContent = error.message; }
    finally { button.disabled = false; }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0], form = event.target.closest('form');
    if ($('#product-price')) $('#product-price').textContent = option.dataset.price;
    const button = $('button[type=submit]', form); button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Currently sold out' : 'Add to your flower bag +';
  });
  $$('[data-product-gallery]').forEach(gallery => {
    const track = $('[data-gallery-track]', gallery), controls = $('[data-gallery-dots]', gallery);
    if (!controls) return;
    const dots = $$('button', controls);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    track.addEventListener('scroll', () => {
      const next = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      if (!Number.isInteger(next) || next === current) return;
      dots[current].removeAttribute('aria-current');
      dots[next].setAttribute('aria-current', 'true');
      current = next;
    }, { passive: true });
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: index * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      });
    });
    controls.hidden = false;
  });
  $('#overlay')?.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { close(); $('.nav-links')?.classList.remove('open'); $('.mobile-menu')?.setAttribute('aria-expanded','false'); }
    if (event.key !== 'Tab' || !drawer || drawer.hidden) return;
    const nodes = $$('button:not(:disabled),a[href]', drawer).filter(n => n.getClientRects().length), first = nodes[0], last = nodes.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  savedButtons(); refreshCart().catch(() => toast('Your bag is temporarily unavailable. Please refresh before checkout.'));
})();
